import BaseStore from 'stores/baseStore.js'

const api = useFeathers()
const servicePath = 'users'
const baseStore = new BaseStore(servicePath)

export const useUserStore = defineStore('users', {
  state: () => ({
    ...baseStore.state,
    user: null,
    defaultSchema: {
      firstName: {
        value: '',
        type: 'string',
        required: true,
      },
      lastName: {
        value: '',
        type: 'string',
        required: true,
      },
      email: {
        value: '',
        type: 'string',
        required: true,
      },
      roles: {
        value: [],
        type: 'option',
        required: true,
        options: [],
        multiple: true,
        chips: true,
      },
      locale: {
        value: 'nl-NL',
        type: 'option',
        required: true,
        options: ['nl-NL', 'en-US'],
        multiple: false,
      },
      regionalSettings: {
        value: 'nl-NL',
        type: 'option',
        required: true,
        options: ['nl-NL', 'en-US'],
        multiple: false,
      },
    },
  }),
  getters: {
    currentRegionalSettings: (state) => {
      const regionalLang = state.user?.regionalSettings ? state.user.regionalSettings : state.user?.locale
      return {
        lang: regionalLang,
        dateFormat: regionalLang === 'nl-NL' ? 'dd-MM-yyyy' : 'MM/dd/yyyy',
        dateTimeFormat: regionalLang === 'nl-NL' ? 'dd-MM-yyyy HH:mm' : 'MM/dd/yyyy HH:mm',
        timeFormat: regionalLang === 'nl-NL' ? 'HH:mm' : 'HH:mm',
        mask: regionalLang === 'nl-NL' ? '##-##-####' : '##/##/####',
        dateTimeMask: regionalLang === 'nl-NL' ? '##-##-#### ##:##' : '##/##/#### ##:##',
      }
    },
  },
  actions: {
    ...baseStore.actions,
    setAvatar(avatar) {
      if (!this.user) return
      this.user.avatar = avatar
    },
    setAvatarInfo(avatarInfo) {
      if (!this.user) return
      this.user.avatarInfo = avatarInfo
    },
    createFormInstance() {
      return structuredClone(toRaw(this.defaultSchema))
    },
  },
})
